import { breakpoints } from '@/src/utils/mediaQuery';
import { Card, Checkbox, Ul } from '@ovotech/nebula';
import styled from 'styled-components';

export const LoadingStyledCard = styled(Card)`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2.3rem;
  margin-bottom: 32px;
  svg.loading-icons {
    margin-right: 2px;
    margin-left: 2px;
    @media only screen and (min-width: 550px) {
      margin-right: 20px;
      margin-left: 20px;
    }
  }
`;

export const StyledTermsCheckbox = styled(Checkbox)`
  position: absolute;
  margin-top: 100px;
`;

export const StyledUl = styled(Ul)`
  list-style-type: none;
  margin-left: 0;
`;

export const ButtonGroupWrapper = styled.div`
  ${({ theme: { mediaQueries } }) => `
    margin-top: auto;
    div {
      display: flex;
      flex-direction: column-reverse;
      a {
        margin-bottom: 2rem;
      }
    }

${mediaQueries.mediumAndUp} {
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    a {
      height: 50%;
    }
  }
};
`}
`;

export const Divider = styled.div`
  ${({ theme: { colors } }) => `
    border-top: 1px solid ${colors.brand.grey.base};
  `}
  margin-bottom: 3.2rem;
`;

export const PromoCutout = styled.div`
  margin-top: 3.2rem;
  padding: 3.2rem;
  ${({ theme: { colors } }) => `
    background-color: ${colors.brand.sand};
  `};
`;

export const PromoContainer = styled.div`
  display: inline-flex;
  gap: 10px;
  align-items: center;

  @media (${breakpoints.mediumDown}) {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 16px;

    & > * {
      width: 100%;
    }
    & [data-testid='changePromoCodeButton'] {
      width: 100%;
    }
  }
`;
